import React from 'react';
import './StatusBadge.scss';

interface StatusBadgeProps {
  status: string;
}

const StatusBadge: React.FC<StatusBadgeProps> = ({ status }) => {
  const normalizedStatus = status?.toLowerCase() || '';
  const badgeClass = normalizedStatus === 'active' ? 'badge-active' : 'badge-inactive';
  const dotClass = normalizedStatus === 'active' ? 'dot-active' : 'dot-inactive';

  return (
    <div className={`status-badge ${badgeClass}`}>
      <span className={`status-dot ${dotClass}`} />
      {status}
    </div>
  );
};

export default StatusBadge;
